import { Grid, Stack } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { colors } from "../../../common/Theme/Colors";
import { moduleTypes } from "../../../common/users/userTypes";
import { getDayJs, getMoment } from "../../../common/Utils/commonFunction";
import {
  StyledCard,
  StyledTypography,
} from "../../../common/Utils/StyledComponents";
import { showToast } from "../../../common/Utils/ToastMessage";
import {
  useCriticalTaskMutation,
  useGetRiskFactorTaskCollectionMutation,
  usePinTaskMutation,
} from "../../../request/Task";
import Translate from "../../../translation/utils/translateFunction";
import DatePickerModal from "../../common/datePickerModal";
import { HomeScreenStrings } from "../../Dashboard/utils";
import IconifyIcon from "../../Icon";
import ListView from "../../ListView";
import DropDownField from "../../TextField/DropdownField";
import { MarkCriticalAndPinTask } from "../Components/utils";
import { SUBTASK_PREFIX } from "../constants";
import { getRiskFactorTaskColumns } from "./column.data";

const RiskFactorTaskListing = ({ fixNavbar }) => {
  const { userData, isRtl, selectedCompanyList } = useSelector(
    (state) => state.formanagement
  );
  const navigate = useNavigate();
  const { state } = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [taskOptions, setTaskOptions] = useState([]);
  const [riskFactorOptions, setRiskFactorOptions] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [durationOptions, setDurationOptions] = useState([]);
  const [selectedTaskOption, setSelectedTaskOption] = useState("SELF");
  const [selectedRiskFactor, setSelectedRiskFactor] = useState("");
  const [selectedFilterGraph, setSelectedFilterGraph] = useState(
    HomeScreenStrings.MONTH
  );
  const [filterSelectedDate, setFilterSelectedDate] = useState();
  const [showDatePickerModal, setShowDatePickerModal] = useState(false);
  const [value, setValue] = useState(getDayJs(getMoment().format()));
  const [lastPageNo, setLastPageNo] = useState(0);
  const [riskFactorListState, setRiskFactorListState] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [
    fetchAllTask,
    {
      data: riskFactorDataList,
      isLoading: isLoadingRiskFactor,
      isError: isRiskFactorError,
      error: RiskFactorError,
      isSuccess: isSuccessRiskFactorTaskList,
      isFetching: riskFactorFetching,
    },
  ] = useGetRiskFactorTaskCollectionMutation();
  const [pinTask, { data: pinTaskData }] = usePinTaskMutation({
    fixedCacheKey: "pinnedTask",
  });

  const [markCritical, { data: markCriticalData }] = useCriticalTaskMutation({
    fixedCacheKey: "criticalTask",
  });
  const requestPayload = useMemo(() => {
    const requestObjectWithFilters = {
      pageNo: currentPage,
      duration: selectedFilterGraph,
      customDate: filterSelectedDate ? filterSelectedDate : undefined,
      riskFactor:
        selectedRiskFactor === "All"
          ? riskFactorOptions
            ?.filter((item) => item?.value !== "All")
            ?.map((item) => item?.value)
          : selectedRiskFactor
            ? [selectedRiskFactor]
            : [],
      taskFor: selectedTaskOption,
      companyId: selectedCompanyList.map((idItem) => idItem.value),
    };

    return requestObjectWithFilters;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedRiskFactor,
    filterSelectedDate,
    selectedFilterGraph,
    selectedTaskOption,
    currentPage,
  ]);
  useEffect(() => {
    setIsLoading(true);
    fetchAllTask(requestPayload);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestPayload, pinTaskData, markCriticalData]);
  useEffect(() => {
    if (riskFactorDataList?.data && isSuccessRiskFactorTaskList) {
      const { pageInfo, nodes } = riskFactorDataList.data;
      setRiskFactorListState(nodes);
      setLastPageNo(pageInfo.lastPageNo);
      setIsLoading(false);
    }
    if (RiskFactorError && isRiskFactorError) {
      showToast({
        type: "error",
        message: JSON.stringify(RiskFactorError),
      });
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [riskFactorDataList, RiskFactorError, isSuccessRiskFactorTaskList]);

  useEffect(() => {
    if (state?.selectedFilter.teamsFilter && state.isFromDashboard) {
      setSelectedTaskOption(state.selectedFilter.teamsFilter);
      setSelectedFilterGraph(state.selectedFilter.durationFilter);
      setShowFilter(true);
      state?.selectedFilter.customFilterSelectedDate &&
        setFilterSelectedDate(state.selectedFilter.customFilterSelectedDate);
    } else {
      setSelectedTaskOption("SELF");
    }
  }, [state]);
  useEffect(() => {
    if (userData && userData?.masterData) {
      const data = userData?.moduleAccess?.find(
        (item) => Object.keys(item)[0] === moduleTypes.DASHBOARDFILTERS
      );

      const { riskFactor, duration } = userData?.masterData;
      // const updatedTaskOptions = taskFor?.map((item) => ({
      //     label: item.name,
      //     value: item.value,
      // }));
      const updatedTaskOptions = Object.values(data?.dashboardFilter?.children)
        ?.filter((item) => item?.isEnable)
        .map((item) => ({
          label: Translate(`manageTask:${item.label}`),
          value: item.label?.toUpperCase(),
        }));
      const updatedRiskFactorOptions = riskFactor?.map((item) => ({
        label: item.name,
        value: item.value,
      }));
      const updatedDurationOptions = duration?.map((item) => ({
        label: item.name,
        value: item.value,
      }));
      setDurationOptions(updatedDurationOptions);
      setRiskFactorOptions([
        {
          label: "All",
          value: "All",
        },
        ...updatedRiskFactorOptions,
      ]);
      setSelectedRiskFactor("All");
      setTaskOptions(updatedTaskOptions);
    }
  }, [userData]);
  const hideDatePickerModal = () => {
    setShowDatePickerModal(false);
  };
  const showFilters = () => {
    setShowFilter(!showFilter);
  };

  const clearFilter = () => {
    setCurrentPage(1);
    setSelectedTaskOption(state?.selectedFilter?.teamsFilter ? state?.selectedFilter?.teamsFilter : "SELF");
    setSelectedRiskFactor("All");
    setSelectedFilterGraph(HomeScreenStrings.MONTH);
  };
  const setFilterValue = (item, placeholder) => {
    setCurrentPage(1);
    switch (placeholder) {
      case Translate("taskReport:staffLabel"):
        item.target.value !== placeholder
          ? setSelectedTaskOption(item.target.value)
          : setSelectedTaskOption("");

        break;
      case Translate("common:risk"):
        item.target.value !== placeholder
          ? setSelectedRiskFactor(item.target.value)
          : setSelectedRiskFactor("");

        break;
      default:
        break;
    }
  };
  const CustomActionCellRender = (params) => {
    const { taskNumber } = params?.row;
    const isSubtask = taskNumber?.startsWith(SUBTASK_PREFIX);
    return (
      <div className="headerMargin">
        <a
          href="/#"
          className="nav-link dropdown-toggle"
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i className="fa fa-ellipsis-v manageIconColor" />
        </a>
        <div className="dropdown-menu dropdownAlignment dropdownIconMenu">
          <MarkCriticalAndPinTask
            taskId={params?.row?.taskId || params?.row?._id}
            isPinnedEnabled={params?.row?.isPinnedEnabled}
            isMarkCriticalEnabled={params?.row?.isMarkAsCriticalEnabled}
            hasFlagged={params?.row?.hasFlagged}
            hasPinned={params?.row?.hasPinned}
            markAsCritical={markCritical}
            pinTask={pinTask}
          />
          <div
            className="manageIconColor ml-3 cursor-pointer dropdown-item"
            onClick={() =>
              navigate(isSubtask ? "/subtask/view" : "/taskDetails", {
                state: {
                  taskId: params?.row?.taskId,
                  isTaskFilter: true,
                  navigateFrom: "/riskFactorTask",
                },
              })
            }
          >
            <span className="manageIconColor fa fa-eye" />
            {Translate("manageTask:viewTask")}
          </div>
        </div>
      </div>
    );
  };

  const CustomSrCellRender = (params) => {
    return (
      <StyledTypography component="span" sx={{ color: colors.primary_009 }}>
        {params?.api?.getRowIndexRelativeToVisibleRows(params?.row?._id) +
          1 +
          (currentPage - 1) * 10}
      </StyledTypography>
    );
  };
  return (
    <Grid
      item
      xs={12}
      className={`section-body ${isRtl ? "rtlMargin" : "ltrMargin"} ${fixNavbar ? "marginTop" : ""
        } `}
    >
      <StyledCard variant="outlined">
        <div className="container-fluid">
          <div className="tab-content">
            <div className="card cardHeight">
              <div
                className={`card-header fixedHeight ${showFilter ? "row" : ""}`}
              >
                <Stack
                  flexDirection={"row"}
                  alignItems={"center"}
                  className={`${showFilter ? "col-lg-6 col-md-12" : ""}`}
                >
                  <i
                    className="icon fe fe-arrow-left mr-3 icon-size backnavigation-iconColor cursor-pointer"
                    onClick={() => navigate("/manageTask")}
                    title={Translate("common:backToolTip")}
                  />
                  <h5 className="page-title">
                    {Translate("manageTask:riskFactor")}
                  </h5>
                </Stack>

                <div
                  className={`card-options ${showFilter && "manageTaskFilterDiv col-lg-6 col-md-12"
                    } `}
                >
                  <div className="sort_stat commentTextField">
                    {showFilter ? (
                      <div className="row" style={{ width: "100%" }}>
                        <div className="col-lg-5 col-md-5 col-sm-5" />
                        <div
                          className="col-lg-3 col-md-3 col-sm-3"
                          style={{ marginTop: "9px" }}
                        >
                          <StyledTypography
                            sx={{ color: colors.primary_009 }}
                            component="span"
                          >
                            {Translate("common:task")}
                          </StyledTypography>
                          <div className="managetaskCustomFilters">
                            <div className="form-group cursor-pointer">
                              <DropDownField
                                options={taskOptions}
                                className={
                                  "form-control textFieldHeight cursor-pointer"
                                }
                                placeholder={Translate(
                                  "taskReport:staffPlaceHolder"
                                )}
                                onChange={(item) =>
                                  setFilterValue(
                                    item,
                                    Translate("taskReport:staffLabel")
                                  )
                                }
                                value={selectedTaskOption}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-lg-4 col-md-4 col-sm-4"
                          style={{ marginTop: "9px" }}
                        >
                          <StyledTypography
                            sx={{ color: colors.primary_009 }}
                            component="span"
                          >
                            {Translate("common:risk")}
                          </StyledTypography>
                          <div className="managetaskCustomFilters">
                            <div className="form-group cursor-pointer">
                              <DropDownField
                                options={riskFactorOptions}
                                className={
                                  "form-control textFieldHeight cursor-pointer"
                                }
                                placeholder={Translate(
                                  "taskReport:staffPlaceHolder"
                                )}
                                onChange={(item) =>
                                  setFilterValue(item, Translate("common:risk"))
                                }
                                value={selectedRiskFactor}
                              />
                            </div>
                          </div>
                        </div>
                        {/* <div
                                                    className="col-lg-4 col-md-4 col-sm-4 dateRangeBox"
                                                    style={{ marginTop: "9px", }}
                                                >
                                                    <StyledTypography
                                                        sx={{ color: colors.primary_009 }}
                                                        component="span"
                                                    >
                                                        {Translate("common:duration")}
                                                    </StyledTypography>
                                                    <div style={{ width: "100%" }} id="manageTask">
                                                        <DashboardDropDown
                                                            options={durationOptions}
                                                            className={"cursor-pointer px-1"}
                                                            placeholder={Translate(
                                                                "taskReport:priorityPlaceHolder"
                                                            )}
                                                            onSelect={(value) => {
                                                                if (value === HomeScreenStrings.CUSTOM) {
                                                                    setShowDatePickerModal(true);
                                                                } else {
                                                                    setSelectedFilterGraph(value);
                                                                    setValue(getDayJs(getMoment().format()));
                                                                    setFilterSelectedDate();
                                                                }
                                                            }}
                                                            value={selectedFilterGraph}
                                                        />
                                                    </div>
                                                </div> */}
                        {/* <div
                                                    className="col-lg-1 col-md-1 col-sm-1"
                                                /> */}
                      </div>
                    ) : null}
                    <div
                      className="filterIconBox  mx-2 customFilterIconBoxAlignment"
                      style={{
                        width: "100%",
                        textAlign: "center",
                      }}
                      onClick={() => {
                        showFilter && clearFilter();
                        showFilters(!showFilter);
                      }}
                    >
                      {showFilter ? (
                        <span
                          data-toggle="tooltip"
                          title={Translate("common:clearFilterToolTip")}
                        >
                          <IconifyIcon
                            icon="mdi:filter-off"
                            width="19"
                            className="dateRangeFilterIcon"
                          />
                        </span>
                      ) : (
                        <span
                          data-toggle="tooltip"
                          title={Translate("common:showFilterToolTip")}
                        >
                          <IconifyIcon
                            icon="fa:filter"
                            width="14"
                            className="dateRangeFilterIcon"
                          />
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <ListView
                  columns={getRiskFactorTaskColumns(
                    CustomSrCellRender,
                    CustomActionCellRender,
                    false
                  )}
                  rows={riskFactorListState}
                  autoHeight
                  sortingMode="server"
                  onPaginationChange={setCurrentPage}
                  currentPage={currentPage}
                  showShimmer={
                    riskFactorFetching || isLoading || isLoadingRiskFactor
                  }
                  showLoader={isLoading || isLoadingRiskFactor}
                  totalPageCount={lastPageNo}
                />
              </div>
            </div>
          </div>
        </div>
        <DatePickerModal
          value={value}
          setValue={setValue}
          closeDatePickerModal={hideDatePickerModal}
          setFilterSelectedDate={setFilterSelectedDate}
          showDatePickerModal={showDatePickerModal}
          handleApply={() => setSelectedFilterGraph(HomeScreenStrings.CUSTOM)}
        />
      </StyledCard>
    </Grid>
  );
};
export default RiskFactorTaskListing;
